import { render, staticRenderFns } from "./PrintTalentAnalysis.vue?vue&type=template&id=5061ba52&scoped=true&"
import script from "./PrintTalentAnalysis.vue?vue&type=script&lang=js&"
export * from "./PrintTalentAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./PrintTalentAnalysis.vue?vue&type=style&index=0&id=5061ba52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5061ba52",
  null
  
)

export default component.exports